import React from 'react';
import { Message, Transition } from 'semantic-ui-react';

import './css/index.css';

export type Props = {
  body: string;
  isWarning?: boolean;
  visible: boolean;
  erase: any;
};

export const FlashMessage: React.FC<Props> = ({
  body,
  isWarning = false,
  visible,
  erase,
}) => (
  <Transition visible={visible} animation="fade" duration={800}>
    <Message
      className="flash-message"
      data-testid={isWarning ? 'error-message' : 'success-message'}
      negative={isWarning}
      onDismiss={erase}
      positive={!isWarning}
    >
      {body}
    </Message>
  </Transition>
);
